export function TableLoader({ rows = 5, title = 'Loading records...' }: { rows?: number; title?: string }) {
  return (
    <div className="table-wrapper relative overflow-hidden rounded-xl border border-slate-200 bg-white shadow-xs">
      {/* Top Animated Gradient Bar */}
      <div className="h-1 w-full bg-slate-100 overflow-hidden relative">
        <div className="h-full bg-gradient-to-r from-brand-500 via-emerald-500 to-brand-600 animate-pulse w-full" />
      </div>

      {/* Header Loading Status Indicator */}
      <div className="bg-slate-50/80 px-4 py-3 border-b border-slate-200 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-3 w-3 bg-brand-600" />
          </span>
          <span className="text-xs font-bold text-slate-700 uppercase tracking-wider">{title}</span>
        </div>
        <div className="h-3 w-20 bg-slate-200/80 rounded animate-pulse" />
      </div>

      {/* Skeleton Rows with Variable Columns */}
      <div className="divide-y divide-slate-100">
        {[...Array(rows)].map((_, i) => (
          <div key={i} className="px-4 py-3.5 flex items-center justify-between gap-4 animate-pulse">
            <div className="flex items-center gap-3 flex-1">
              <div className="h-4 w-28 bg-slate-200/90 rounded-md" />
              <div className="h-4 w-40 bg-slate-100 rounded-md hidden sm:block" />
              <div className="h-4 w-24 bg-slate-100 rounded-md hidden md:block" />
              <div className="h-4 w-20 bg-slate-100 rounded-md hidden lg:block" />
            </div>
            <div className="flex items-center gap-2">
              <div className="h-5 w-16 bg-slate-100 rounded-full" />
              <div className="h-7 w-14 bg-slate-200/70 rounded-lg" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TableLoader;
